import { ProgressBar } from "@shopify/polaris";
import React, { useState } from "react";
import ElementsContextType from "../../types/ElementsContextType";
import { ElementsContext } from "../contexts/ElementsContext";
import styles from "./Bar.module.css";

export default function Bar() {
    const [completed, setCompleted] = useState<number>(0);
    const [progress, setProgress] = useState<number>(0);
    const { elements } = React.useContext(
        ElementsContext
    ) as ElementsContextType;

    React.useEffect(() => {
        let completedCount = 0;
        elements.forEach((element) => {
            const count = element.Images.length;
            if (count >= element.MinItems && element.MinItems != null) {
                completedCount++;
            }
        });

        setCompleted(completedCount);
        if (elements.length > 0) {
            setProgress(Math.round((completedCount / elements.length) * 100));
        }
    }, [elements]);

    return (
        <div className={styles.bar}>
            Completed : {completed}/{elements.length}
            <ProgressBar progress={progress} size={"small"} />
        </div>
    );
}
